// The ranges every history chart offers, shortest first. `key` is what the API
// accepts as ?range=. Shared so the devices overview and a plant's Trends &
// Analytics stay in step: one ladder, one set of labels, one availability rule.
//
// unlocksAfterDays is the age a device's oldest reading must exceed before the
// range is worth offering: a range that would only repeat what the previous one
// already shows is left disabled. So 30d needs a reading older than a week, 1y
// needs one older than a month, and All needs one older than a year — which is
// also the only thing that distinguishes All from 1y. 7d is always available,
// including for a device that has never reported at all, so a chart always has
// a selected range to fall back on.
export const HISTORY_RANGES = [
	{ key: '7d', label: '7d', unlocksAfterDays: 0, description: 'the last 7 days' },
	{ key: '30d', label: '30d', unlocksAfterDays: 7, description: 'the last 30 days' },
	{ key: '1y', label: '1y', unlocksAfterDays: 30, description: 'the last year' },
	{ key: 'all', label: 'All', unlocksAfterDays: 365, description: 'all recorded history' },
];

export const DEFAULT_HISTORY_RANGE = '7d';

const DAY_MS = 24 * 60 * 60 * 1000;

// isRangeAvailable answers whether `range` would show anything the shorter
// ranges do not. firstReadingAt is the device's oldest reading as an ISO string,
// or null when it has never reported; while it is still unknown only the default
// range is offered, so the buttons never promise data that turns out not to
// exist.
export const isRangeAvailable = (range, firstReadingAt, now = Date.now()) => {
	if (range.unlocksAfterDays === 0) return true;
	if (!firstReadingAt) return false;
	return new Date(firstReadingAt).getTime() < now - range.unlocksAfterDays * DAY_MS;
};

export default HISTORY_RANGES;
